export default "__VITE_ASSET__DYvzdjs8__"